<script setup lang="ts">
import CheckBox from '@/uiKit/CheckBox.vue'
import Menu from '@/uiKit/Menu'
import { useId } from 'vue'

defineProps<{ label: string; selected: boolean }>()

defineEmits<{
  (e: 'toggle' | 'highlight'): void
}>()

const id = useId()
</script>

<template>
  <Menu.Item
    :id="id"
    :aria-label="label"
    @select="$emit('toggle')"
    @highlight="$emit('highlight')"
  >
    <template #prefix>
      <CheckBox
        :checked="selected"
        :aria-labelledby="id"
      />
    </template>
    <span
      v-if="label"
      class="ml-1 grow truncate"
      :title="label"
      >{{ label }}</span
    >
  </Menu.Item>
</template>
